const CATEGORY_EMOJI_RULES = [
    { match: /pizza/i, emoji: '🍕' },
    { match: /paste|pasta|spaghetti|tagliatelle/i, emoji: '🍝' },
    { match: /burger|hamburger/i, emoji: '🍔' },
    { match: /salat/i, emoji: '🥗' },
    { match: /ciorb|sup[ăa]|soup/i, emoji: '🍲' },
    { match: /gr[ăa]tar|grill|carne|mici|steak|bbq/i, emoji: '🥩' },
    { match: /pui|chicken/i, emoji: '🍗' },
    { match: /sushi|sashimi/i, emoji: '🍣' },
    { match: /pe[șs]te|fish/i, emoji: '🐟' },
    { match: /desert|pr[ăa]jitur|tort|dulce|cake|tiramisu|îngheț/i, emoji: '🍰' },
    { match: /mic\s*de\s*jun|breakfast|brunch|omlet/i, emoji: '🍳' },
    { match: /sandwich|shaorma|wrap|kebab|d[öo]ner/i, emoji: '🥙' },
    { match: /aperitiv|starter|entr[eé]e/i, emoji: '🥟' },
    { match: /garnitur|side/i, emoji: '🍟' },
    { match: /cafea|coffee|espresso|latte|cappuccino/i, emoji: '☕' },
    { match: /ceai|tea/i, emoji: '🍵' },
    { match: /suc|fresh|limonad|smoothie|b[ăa]utur/i, emoji: '🥤' },
    { match: /vin|wine/i, emoji: '🍷' },
    { match: /bere|beer/i, emoji: '🍺' },
    { match: /cocktail|spirits|whisky|vodka/i, emoji: '🍸' },
    { match: /cocktail|mocktail/i, emoji: '🍹' },
    { match: /special|recomand/i, emoji: '⭐' },
    { match: /copii|kids|children/i, emoji: '🧒' },
    { match: /vegan|vegetarian/i, emoji: '🥬' },
];

export const CATEGORY_EMOJI_OPTIONS = [
    '🍕', '🍝', '🍔', '🥗', '🍲', '🥩', '🍗', '🐟', '🍣', '🥘',
    '🌮', '🌯', '🥙', '🍟', '🍳', '🥐', '🧀', '🍰', '🧁', '🍩',
    '☕', '🍵', '🥤', '🍺', '🍷', '🥂', '🍹', '🍸', '🍾', '⭐', '🍽',
];

export function suggestCategoryEmoji(name, fallback = '🍽') {
    const label = (name || '').trim();
    if (!label) return fallback;
    for (const rule of CATEGORY_EMOJI_RULES) {
        if (rule.match.test(label)) return rule.emoji;
    }
    return fallback;
}

export function displayCategoryEmoji(category) {
    if (category?.emoji) return category.emoji;
    return suggestCategoryEmoji(category?.name);
}
